/*
 * Vajihi Labs - Email Signature Builder
 * Tiny shared-state module: the single source-of-truth signature model that
 * the Design tab and Theme Library both read and mutate. Apply mode keeps
 * its own separate working copy (see apply.ts) so loading someone else's
 * shared code there never overwrites your own in-progress design.
 */

import type { SignatureModel } from "./themes";
import { loadModel, saveModel } from "./model";

let current: SignatureModel = loadModel();
type Listener = (model: SignatureModel) => void;
const listeners: Listener[] = [];

export function getModel(): SignatureModel {
  return current;
}

export function setModel(model: SignatureModel, persist = true): void {
  current = model;
  if (persist) saveModel(current);
  listeners.slice().forEach((fn) => fn(current));
}

export function updateModel(mutator: (model: SignatureModel) => void, persist = true): void {
  mutator(current);
  setModel(current, persist);
}

export function onModelChange(listener: Listener): void {
  listeners.push(listener);
}
